import React from "react";
import {
  FormField,
  Box,
  FormRadioCheckboxButton,
  FormRadioCheckboxGroup,
  Button
} from "@nef/core";
import styled from "styled-components";

const StyledIssuerInformation = styled(Box)`
  width: 500px;
  margin: auto;
  margin-top: 50px;

   .button {
     margin-left: 75px;
   }

   .action-buttons{
    margin-bottom: 20px;
  }
`;

export default StyledIssuerInformation;
